import configureStore from './configureStore';
import authenticate from './authenticate';

const store = configureStore();
store.dispatch(authenticate)

export default store;